module.exports = __webpack_public_path__ + "static/media/fly-icon.df74658b.png";